import { Injectable } from '@angular/core';

import { HttpClient , HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from './models';
import * as myGlobal from './globals'; 

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'auth-key': myGlobal.call_api_key ,
    });
    options = { headers: this.headers };

    constructor(private http: HttpClient) {
        console.log('Init!');
       // localStorage.removeItem('currentUser');
     //   console.log('Get from local storage:' ,localStorage.getItem('currentUser'));

        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        //let url = window.location.href.replace(/(^\w+:|^)\/\//, '');
        //console.log("Run to here! POST " + myGlobal.api_endpoint_1 + 'auth/local');
        return this.http.post<any>(myGlobal.api_endpoint_1 + 'auth/local', { identifier: username, password  },this.options)
            .pipe(map(data => {
                console.log('User:',data)
                // login successful if there's a jwt token in the response
                // if (data.result='nodata') return faile
                // if (user && user.token) {
                //     // store user details and jwt token in local storage to keep user logged in between page refreshes
                //     localStorage.setItem('currentUser', JSON.stringify(user));
                //     //this.currentUserSubject.next(user);
                // }
                localStorage.setItem('currentUser', JSON.stringify(data));
                this.currentUserSubject.next(data);
                return data;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    checkTimeOut(result, router): boolean {

        if (result.hasOwnProperty('result')) {
            console.log('Check timeout: result = ' + JSON.stringify(result));
    
            if (result.result=='timeout') {
                localStorage.removeItem('currentUser');
                this.currentUserSubject.next(null);
                router.navigate(['/login']);            
                alert("Time out! Please login again!");
                return false;
            }
        } 
        //router.navigate(['/login']);    
        return true;
    }
    
}
